<template>
  <div>
    <el-dialog :title="$t('app.auto_185_1f46ba2d')" custom-class="MyDialog cash-data-modal" :visible.sync="isShowBankRransferDialog" :close-on-click-modal="false"
      @close="closeCashDataModal" width="1000px" append-to-body>
      <div
        class="PaytoSongShu"
        :class="{ 'PaytoSongShu--en': $i18n.locale === 'en-US' }"
      >
        <div class="right_content">
          <b class="payee-line payee-line--company">{{ companyInfo.companyName }}</b>
          <b class="payee-line">{{ $t('equipment.bankAccount') }}{{ labelSep }}{{ companyInfo.bankAccount }}</b>
          <b class="payee-line">{{ $t('equipment.bankName') }}{{ labelSep }}{{ companyInfo.bankName }}</b>
        </div>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form
            :model="bankRransferForm"
            ref="bankRransferForm"
            :label-position="isUsLocale ? 'top' : 'right'"
            :label-width="isUsLocale ? '' : $getColumnWidth(100, 130) + 'px'"
            :class="{ 'cash-data-form--en': isUsLocale }"
          >
            <el-row>
              <el-col :span="isUsLocale ? 24 : 12">
                <el-form-item :label="$t('app.amount')" prop="money">
                  <el-input v-model="bankRransferForm.money" style="width: 100%" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isUsLocale ? 24 : 12">
                <el-form-item :label="$t('equipment.payTimeLabel') + labelSep" prop="payTime" :rules="[
                  {
                    required: true,
                    message: this.$t('equipment.payTimeRequired'),
                    trigger: 'blur'
                  }
                ]">
                  <el-date-picker v-model="bankRransferForm.payTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"
                    :placeholder="$t('equipment.pleaseSelectPayTime')">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item :label="$t('equipment.paySerialNo') + labelSep" prop="paySysNo">
              <el-input :placeholder="$t('equipment.pleaseEnterPaySerialNo')" v-model="bankRransferForm.paySysNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipment.payVoucher') + labelSep" prop="fileList" :rules="[
              {
                required: bankRransferForm.fileUrl != '' ? false : true,
                message: this.$t('equipment.payVoucherRequired')
              }
            ]">
              <div :class="{ 'pay-voucher-hint--en': isUsLocale }">
                <span>{{ $t('equipment.payVoucherTip') }}</span>
                <a v-if="!isUsLocale" class="credential-instance" @click="previewImage">{{ $t('equipment.credentialInstance') }}</a>
              </div>
              <el-upload ref="upload" class="upload-demo" action="#" accept=".jpg,.jpeg,.png" :on-remove="handleRemove"
                :before-remove="beforeRemove" :on-change="handleSetUploadData" :on-preview="handlePictureCardPreview"
                multiple list-type="picture-card"  :limit="1" :auto-upload="false" :on-exceed="handleExceed"
                :file-list="fileList" :before-upload="handleBeforeUpload">
                <i class="el-icon-plus"></i>
                <!-- <el-button type="primary">{{ $t('app.clickUpload') }}</el-button> -->
              </el-upload>
            </el-form-item>
            <el-form-item :label="$t('equipment.payRemark') + labelSep" prop="remark">
              <el-input type="textarea" v-model="bankRransferForm.remark" :placeholder="$t('equipment.pleaseEnterPayRemark')" maxlength="500"
                :autosize="{ minRows: 4, maxRows: 8 }" show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCashDataModal">{{ $t('app.cancel') }}</el-button>
        <el-button type="primary" @click="submitPay('bankRransferForm')">{{ $t('app.auto_185_1f46ba2d') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="showImageDemo">
      <img class="preview-demo-image" src="@/assets/images/agent/demo.png" />
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { agentSingleBankPay } from "@/api/AccountInterface";
import { getBaseUrl } from "@/util/config";
import axios from "axios";
import LoginUserHelper from "@/util/LoginUserHelper";

export default {
  data() {
    return {
      bankRransferForm: {
        money: "",
        payTime: "",
        paySysNo: "",
        remark: "",
        fileUrl: ""
      },
      rules: {
        payTime: [
          { required: true, message: this.$t('equipment.pleaseSelectPayTime'), trigger: "blur" }
        ]
      },
      isShowBankRransferDialog: false,
      fileList: [],
      showImageDemo: false,
      campusId: LoginUserHelper.getUserInfo().campusId,
      dialogImageUrl: '',
      dialogVisible:false
    };
  },
  props: {
    cashDataModalVisible: {
      type: Boolean,
      default: false
    },
    formLabelAlign: {
      type: Object,
      default: {}
    },
    companyInfo:{
      type: Object,
      default: {}
    }
  },
  computed: {
    /** 中英文标签与取值之间的分隔符（与 BankRransferModal 一致） */
    labelSep() {
      return this.$i18n.locale === "en-US" ? ": " : "：";
    },
    isUsLocale() {
      return this.$i18n.locale === "en-US";
    }
  },
  watch: {
    cashDataModalVisible: {
      handler(newValue, oldValue) {
        this.isShowBankRransferDialog = newValue;
        this.fileList = [];
      },
      immediate: true
    },
    formLabelAlign: {
      handler(newValue, oldValue) {
        if (newValue.elsePayMoney) {
          this.bankRransferForm.money = newValue.elsePayMoney;
        }
      },
      immediate: true
    }
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    // 取消
    closeCashDataModal() {
      this.$emit("closeCashDataModal");
    },
    // 支付
    submitPay(formName) {
      const list = [];
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.bankRransferForm.fileUrl != "") {
            list.push(this.bankRransferForm.fileUrl);
          }
          const { money, paySysNo, payTime, remark } = this.bankRransferForm;
          agentSingleBankPay({
            campusId: this.campusId,
            fileUrl: list,
            money: money,
            paySysNo: paySysNo,
            payTime: this.convertDateString(payTime),
            remark: remark
          }).then(ret => {
            if (ret.code === 0) {
              this.$message({
                message: this.$t('equipment.paymentSuccess'),
                type: "success"
              });
              this.$emit("cashDataModalSuccess");
            } else {
              this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('equipment.paymentFail'));
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除图片
    handleRemove(file) {
      this.bankRransferForm.fileUrl = "";
      this.bankRransferForm.fileName = "";
    },
	//检验
	handleBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        //限制图片 格式、size、
        const isJPG = file.type === "image/jpeg";
        const isJPEG = file.type === "image/jpeg";
        const isGIF = file.type === "image/gif";
        const isPNG = file.type === "image/png";
        const isBmp = file.type === "image/bmp";
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!(isJPG || isGIF || isPNG || isJPEG || isBmp)) {
          this.$message.error(
            this.$t('finance.onlyImageFormatJpg')
          );
          // this.fileLength--;
          return reject(false);
        }
        if (!isLt5M) {
          this.$message.error(this.$t('finance.exceed5MLimitUpload'));
          return reject(false);
        }
        return resolve(true);
      });
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSetUploadData(item) {
      const isLt5M = item.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$refs.upload.clearFiles()
        this.$message({
          message: this.$t('app.uploadFileSize5MB'),
          type: 'warning'
        })
        return false
      }
      let FormDatas = new FormData();
      FormDatas.append("file", item.raw);
      let BASE_URL = getBaseUrl();
      axios
        .post(`${BASE_URL}base/upload/uploadPicture?type=record`, FormDatas, {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: LoginUserHelper.getUserToken()
          }
        })
        .then(res => {
          console.log("res", res);
          if (res.code == 0) {
            console.log("res.data", res.data);
            let { fileName, uploadPath } = res.data;
            this.bankRransferForm.fileName = fileName;
            this.bankRransferForm.fileUrl = uploadPath;
          } else {
            this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs));
          }
        });
    },
    handleExceed() { },
    previewImage() {
      this.showImageDemo = true;
    },
    convertDateString(inputDateString) {
      // 创建一个Date对象，将给定的时间字符串作为参数
      let date = new Date(inputDateString);
      // 获取年份、月份、日期、小时、分钟和秒
      let year = date.getUTCFullYear();
      let month = date.getUTCMonth() + 1;
      let day = date.getUTCDate();
      let hours = date.getUTCHours();
      let minutes = date.getUTCMinutes();
      let seconds = date.getUTCSeconds();
      // 在每个数字前面添加"0"以保持格式一致
      month = (month < 10 ? "0" : "") + month;
      day = (day < 10 ? "0" : "") + day;
      hours = (hours < 10 ? "0" : "") + hours;
      minutes = (minutes < 10 ? "0" : "") + minutes;
      seconds = (seconds < 10 ? "0" : "") + seconds;
      // 返回格式化的日期字符串
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase-info {
  color: rgb(74, 131, 232);
  background: rgb(232, 243, 254);
  width: 95%;
  height: 80px;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  padding: 10px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.PaytoSongShu {
  // padding-left: 24px;
  display: flex;
  margin-bottom: 20px;
  justify-content: center;

  .left_content {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 120px;
      height: 120px;
    }
  }

  .right_content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    b {
      font-size: 18px;
      margin-bottom: 20px;
      // margin-left: 28px;
    }
  }

  /** 美版：收款信息纵向排布，避免英文过长挤在一行 */
  &--en .right_content {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 10px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  &--en .right_content .payee-line {
    display: block;
    width: 100%;
    margin-bottom: 0;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.45;
    text-align: left;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  &--en .right_content .payee-line--company {
    font-size: 16px;
  }
}

/**
 * 美版：顶置标签时略收紧间距，但保留足够 margin给 rules 错误提示
 *（Element 的 .el-form-item__error 在输入框下方，过小会叠到下一项）
 */
.cash-data-form--en.el-form--label-top {
  ::v-deep .el-form-item {
    margin-bottom: 24px;
  }

  ::v-deep .el-form-item__label {
    padding: 0 0 8px 0;
    line-height: 1.4;
  }

  ::v-deep .el-form-item__content {
    line-height: 1.45;
  }

  ::v-deep .el-form-item__error {
    line-height: 1.35;
    padding-top: 6px;
  }

  /** 内层 el-row 在美版仅作堆叠，避免列容器额外撑高 */
  ::v-deep .el-row {
    margin-bottom: 0;
  }
}

/** 美版：付款凭证说明与 picture-card 上传区间距 */
.pay-voucher-hint--en {
  margin-bottom: 14px;
}

.credential-instance {
  text-decoration: underline;
  margin-left: 10px;
  color: #4A83E8;
  cursor: pointer;
}

.preview-demo-image {
  width: 100%;
}
</style>

<!-- 弹层挂到 body，须使用全局选择器 -->
<style lang="scss">
.cash-data-modal.el-dialog {
  display: flex;
  flex-direction: column;
  max-height: min(85vh, 880px);
  margin-bottom: 0;
}

.cash-data-modal .el-dialog__header {
  flex-shrink: 0;
}

.cash-data-modal .el-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.cash-data-modal .el-dialog__footer {
  flex-shrink: 0;
}
</style>
